import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
    this.handleReset = this.handleReset.bind(this);
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught:", error, errorInfo);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.resetKey !== this.props.resetKey && this.state.hasError) {
      this.setState({ hasError: false, error: null });
    }
  }

  handleReset() {
    this.setState({ hasError: false, error: null });
  }

  render() {
    if (this.state.hasError) {
      const errorMessage = this.state.error && this.state.error.message
        ? String(this.state.error.message)
        : '';

      return (
        <div style={{ padding: 20, textAlign: 'center' }}>
          <h3>Component Render Error</h3>
          <p>This section failed to render properly.</p>
          {errorMessage ? <p style={{ color: '#666' }}>{errorMessage}</p> : null}
          <button onClick={this.handleReset} style={{ marginRight: 8 }}>Try Again</button>
          <button onClick={() => window.location.reload()}>Reload Component</button>
        </div>
      );
    }

    return this.props.children;
  }
}